/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ActionTemplate,
    ActionTemplateFromJSON,
    ActionTemplateToJSON,
} from '../models/ActionTemplate';
import {
    type ActionTemplateCreate,
    ActionTemplateCreateFromJSON,
    ActionTemplateCreateToJSON,
} from '../models/ActionTemplateCreate';
import {
    type ActionTemplateSortKey,
    ActionTemplateSortKeyFromJSON,
    ActionTemplateSortKeyToJSON,
} from '../models/ActionTemplateSortKey';
import {
    type ActionTemplateUpdate,
    ActionTemplateUpdateFromJSON,
    ActionTemplateUpdateToJSON,
} from '../models/ActionTemplateUpdate';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface ActionsTemplatesCreateActionTemplateRequest {
    actionTemplateCreate: ActionTemplateCreate;
}

export interface ActionsTemplatesDeleteActionTemplateRequest {
    actionTemplateId: string;
}

export interface ActionsTemplatesListActionTemplatesRequest {
    pageSize: number;
    search?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: ActionTemplateSortKey;
}

export interface ActionsTemplatesListActionTemplatesMetadataRequest {
    pageSize: number;
    search?: string | null;
}

export interface ActionsTemplatesReadActionTemplateRequest {
    actionTemplateId: string;
}

export interface ActionsTemplatesUpdateActionTemplateRequest {
    actionTemplateId: string;
    actionTemplateUpdate: ActionTemplateUpdate;
}

export interface ActionsTemplatesValidateCreateActionTemplateRequest {
    actionTemplateCreate: ActionTemplateCreate;
}

export interface ActionsTemplatesValidateUpdateActionTemplateRequest {
    actionTemplateId: string;
    actionTemplateUpdate: ActionTemplateUpdate;
}

/**
 * ActionsTemplatesApi - interface
 * 
 * @export
 * @interface ActionsTemplatesApiInterface
 */
export interface ActionsTemplatesApiInterface {
    /**
     * Creates request options for actionsTemplatesCreateActionTemplate without sending the request
     * @param {ActionTemplateCreate} actionTemplateCreate 
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesCreateActionTemplateRequestOpts(requestParameters: ActionsTemplatesCreateActionTemplateRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new action template.
     * @summary Create an action template
     * @param {ActionTemplateCreate} actionTemplateCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesCreateActionTemplateRaw(requestParameters: ActionsTemplatesCreateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionTemplate>>;

    /**
     * Create a new action template.
     * Create an action template
     */
    actionsTemplatesCreateActionTemplate(requestParameters: ActionsTemplatesCreateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionTemplate>;

    /**
     * Creates request options for actionsTemplatesDeleteActionTemplate without sending the request
     * @param {string} actionTemplateId 
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesDeleteActionTemplateRequestOpts(requestParameters: ActionsTemplatesDeleteActionTemplateRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the action template with the given ID.
     * @summary Delete an action template
     * @param {string} actionTemplateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesDeleteActionTemplateRaw(requestParameters: ActionsTemplatesDeleteActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the action template with the given ID.
     * Delete an action template
     */
    actionsTemplatesDeleteActionTemplate(requestParameters: ActionsTemplatesDeleteActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for actionsTemplatesListActionTemplates without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ActionTemplateSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesListActionTemplatesRequestOpts(requestParameters: ActionsTemplatesListActionTemplatesRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the action templates present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List action templates
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ActionTemplateSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesListActionTemplatesRaw(requestParameters: ActionsTemplatesListActionTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ActionTemplate>>>;

    /**
     * Lists all the action templates present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List action templates
     */
    actionsTemplatesListActionTemplates(requestParameters: ActionsTemplatesListActionTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ActionTemplate>>;

    /**
     * Creates request options for actionsTemplatesListActionTemplatesMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesListActionTemplatesMetadataRequestOpts(requestParameters: ActionsTemplatesListActionTemplatesMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Action template listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesListActionTemplatesMetadataRaw(requestParameters: ActionsTemplatesListActionTemplatesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Action template listing metadata
     */
    actionsTemplatesListActionTemplatesMetadata(requestParameters: ActionsTemplatesListActionTemplatesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for actionsTemplatesReadActionTemplate without sending the request
     * @param {string} actionTemplateId 
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesReadActionTemplateRequestOpts(requestParameters: ActionsTemplatesReadActionTemplateRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the action template.
     * @summary Get an action template
     * @param {string} actionTemplateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesReadActionTemplateRaw(requestParameters: ActionsTemplatesReadActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionTemplate>>;

    /**
     * Returns the action template.
     * Get an action template
     */
    actionsTemplatesReadActionTemplate(requestParameters: ActionsTemplatesReadActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionTemplate>;

    /**
     * Creates request options for actionsTemplatesUpdateActionTemplate without sending the request
     * @param {string} actionTemplateId 
     * @param {ActionTemplateUpdate} actionTemplateUpdate 
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesUpdateActionTemplateRequestOpts(requestParameters: ActionsTemplatesUpdateActionTemplateRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the updated action template.
     * @summary Update an action template
     * @param {string} actionTemplateId 
     * @param {ActionTemplateUpdate} actionTemplateUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesUpdateActionTemplateRaw(requestParameters: ActionsTemplatesUpdateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionTemplate>>;

    /**
     * Returns the updated action template.
     * Update an action template
     */
    actionsTemplatesUpdateActionTemplate(requestParameters: ActionsTemplatesUpdateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionTemplate>;

    /**
     * Creates request options for actionsTemplatesValidateCreateActionTemplate without sending the request
     * @param {ActionTemplateCreate} actionTemplateCreate 
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesValidateCreateActionTemplateRequestOpts(requestParameters: ActionsTemplatesValidateCreateActionTemplateRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new action template without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate an action template,
     * @param {ActionTemplateCreate} actionTemplateCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesValidateCreateActionTemplateRaw(requestParameters: ActionsTemplatesValidateCreateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new action template without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an action template,
     */
    actionsTemplatesValidateCreateActionTemplate(requestParameters: ActionsTemplatesValidateCreateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for actionsTemplatesValidateUpdateActionTemplate without sending the request
     * @param {string} actionTemplateId 
     * @param {ActionTemplateUpdate} actionTemplateUpdate 
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesValidateUpdateActionTemplateRequestOpts(requestParameters: ActionsTemplatesValidateUpdateActionTemplateRequest): Promise<runtime.RequestOpts>;

    /**
     * Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate an action template
     * @param {string} actionTemplateId 
     * @param {ActionTemplateUpdate} actionTemplateUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsTemplatesApiInterface
     */
    actionsTemplatesValidateUpdateActionTemplateRaw(requestParameters: ActionsTemplatesValidateUpdateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an action template
     */
    actionsTemplatesValidateUpdateActionTemplate(requestParameters: ActionsTemplatesValidateUpdateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ActionsTemplatesApi extends runtime.BaseAPI implements ActionsTemplatesApiInterface {

    /**
     * Creates request options for actionsTemplatesCreateActionTemplate without sending the request
     */
    async actionsTemplatesCreateActionTemplateRequestOpts(requestParameters: ActionsTemplatesCreateActionTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['actionTemplateCreate'] == null) {
            throw new runtime.RequiredError(
                'actionTemplateCreate',
                'Required parameter "actionTemplateCreate" was null or undefined when calling actionsTemplatesCreateActionTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/templates/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActionTemplateCreateToJSON(requestParameters['actionTemplateCreate']),
        };
    }

    /**
     * Create a new action template.
     * Create an action template
     */
    async actionsTemplatesCreateActionTemplateRaw(requestParameters: ActionsTemplatesCreateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionTemplate>> {
        const requestOptions = await this.actionsTemplatesCreateActionTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionTemplateFromJSON(jsonValue));
    }

    /**
     * Create a new action template.
     * Create an action template
     */
    async actionsTemplatesCreateActionTemplate(requestParameters: ActionsTemplatesCreateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionTemplate> {
        const response = await this.actionsTemplatesCreateActionTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for actionsTemplatesDeleteActionTemplate without sending the request
     */
    async actionsTemplatesDeleteActionTemplateRequestOpts(requestParameters: ActionsTemplatesDeleteActionTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['actionTemplateId'] == null) {
            throw new runtime.RequiredError(
                'actionTemplateId',
                'Required parameter "actionTemplateId" was null or undefined when calling actionsTemplatesDeleteActionTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/templates/{action_template_id}`;
        urlPath = urlPath.replace('{action_template_id}', encodeURIComponent(String(requestParameters['actionTemplateId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the action template with the given ID.
     * Delete an action template
     */
    async actionsTemplatesDeleteActionTemplateRaw(requestParameters: ActionsTemplatesDeleteActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.actionsTemplatesDeleteActionTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the action template with the given ID.
     * Delete an action template
     */
    async actionsTemplatesDeleteActionTemplate(requestParameters: ActionsTemplatesDeleteActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.actionsTemplatesDeleteActionTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for actionsTemplatesListActionTemplates without sending the request
     */
    async actionsTemplatesListActionTemplatesRequestOpts(requestParameters: ActionsTemplatesListActionTemplatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling actionsTemplatesListActionTemplates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/templates/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the action templates present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List action templates
     */
    async actionsTemplatesListActionTemplatesRaw(requestParameters: ActionsTemplatesListActionTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ActionTemplate>>> {
        const requestOptions = await this.actionsTemplatesListActionTemplatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActionTemplateFromJSON));
    }

    /**
     * Lists all the action templates present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List action templates
     */
    async actionsTemplatesListActionTemplates(requestParameters: ActionsTemplatesListActionTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ActionTemplate>> {
        const response = await this.actionsTemplatesListActionTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for actionsTemplatesListActionTemplatesMetadata without sending the request
     */
    async actionsTemplatesListActionTemplatesMetadataRequestOpts(requestParameters: ActionsTemplatesListActionTemplatesMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling actionsTemplatesListActionTemplatesMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/templates/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Action template listing metadata
     */
    async actionsTemplatesListActionTemplatesMetadataRaw(requestParameters: ActionsTemplatesListActionTemplatesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.actionsTemplatesListActionTemplatesMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Action template listing metadata
     */
    async actionsTemplatesListActionTemplatesMetadata(requestParameters: ActionsTemplatesListActionTemplatesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.actionsTemplatesListActionTemplatesMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for actionsTemplatesReadActionTemplate without sending the request
     */
    async actionsTemplatesReadActionTemplateRequestOpts(requestParameters: ActionsTemplatesReadActionTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['actionTemplateId'] == null) {
            throw new runtime.RequiredError(
                'actionTemplateId',
                'Required parameter "actionTemplateId" was null or undefined when calling actionsTemplatesReadActionTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/templates/{action_template_id}`;
        urlPath = urlPath.replace('{action_template_id}', encodeURIComponent(String(requestParameters['actionTemplateId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the action template.
     * Get an action template
     */
    async actionsTemplatesReadActionTemplateRaw(requestParameters: ActionsTemplatesReadActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionTemplate>> {
        const requestOptions = await this.actionsTemplatesReadActionTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionTemplateFromJSON(jsonValue));
    }

    /**
     * Returns the action template.
     * Get an action template
     */
    async actionsTemplatesReadActionTemplate(requestParameters: ActionsTemplatesReadActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionTemplate> {
        const response = await this.actionsTemplatesReadActionTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for actionsTemplatesUpdateActionTemplate without sending the request
     */
    async actionsTemplatesUpdateActionTemplateRequestOpts(requestParameters: ActionsTemplatesUpdateActionTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['actionTemplateId'] == null) {
            throw new runtime.RequiredError(
                'actionTemplateId',
                'Required parameter "actionTemplateId" was null or undefined when calling actionsTemplatesUpdateActionTemplate().'
            );
        }

        if (requestParameters['actionTemplateUpdate'] == null) {
            throw new runtime.RequiredError(
                'actionTemplateUpdate',
                'Required parameter "actionTemplateUpdate" was null or undefined when calling actionsTemplatesUpdateActionTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/templates/{action_template_id}`;
        urlPath = urlPath.replace('{action_template_id}', encodeURIComponent(String(requestParameters['actionTemplateId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ActionTemplateUpdateToJSON(requestParameters['actionTemplateUpdate']),
        };
    }

    /**
     * Returns the updated action template.
     * Update an action template
     */
    async actionsTemplatesUpdateActionTemplateRaw(requestParameters: ActionsTemplatesUpdateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActionTemplate>> {
        const requestOptions = await this.actionsTemplatesUpdateActionTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActionTemplateFromJSON(jsonValue));
    }

    /**
     * Returns the updated action template.
     * Update an action template
     */
    async actionsTemplatesUpdateActionTemplate(requestParameters: ActionsTemplatesUpdateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActionTemplate> {
        const response = await this.actionsTemplatesUpdateActionTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for actionsTemplatesValidateCreateActionTemplate without sending the request
     */
    async actionsTemplatesValidateCreateActionTemplateRequestOpts(requestParameters: ActionsTemplatesValidateCreateActionTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['actionTemplateCreate'] == null) {
            throw new runtime.RequiredError(
                'actionTemplateCreate',
                'Required parameter "actionTemplateCreate" was null or undefined when calling actionsTemplatesValidateCreateActionTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/templates/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActionTemplateCreateToJSON(requestParameters['actionTemplateCreate']),
        };
    }

    /**
     * Validate data for a new action template without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an action template,
     */
    async actionsTemplatesValidateCreateActionTemplateRaw(requestParameters: ActionsTemplatesValidateCreateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.actionsTemplatesValidateCreateActionTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new action template without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an action template,
     */
    async actionsTemplatesValidateCreateActionTemplate(requestParameters: ActionsTemplatesValidateCreateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.actionsTemplatesValidateCreateActionTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for actionsTemplatesValidateUpdateActionTemplate without sending the request
     */
    async actionsTemplatesValidateUpdateActionTemplateRequestOpts(requestParameters: ActionsTemplatesValidateUpdateActionTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['actionTemplateId'] == null) {
            throw new runtime.RequiredError(
                'actionTemplateId',
                'Required parameter "actionTemplateId" was null or undefined when calling actionsTemplatesValidateUpdateActionTemplate().'
            );
        }

        if (requestParameters['actionTemplateUpdate'] == null) {
            throw new runtime.RequiredError(
                'actionTemplateUpdate',
                'Required parameter "actionTemplateUpdate" was null or undefined when calling actionsTemplatesValidateUpdateActionTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/actions/templates/{action_template_id}/validate`;
        urlPath = urlPath.replace('{action_template_id}', encodeURIComponent(String(requestParameters['actionTemplateId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ActionTemplateUpdateToJSON(requestParameters['actionTemplateUpdate']),
        };
    }

    /**
     * Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an action template
     */
    async actionsTemplatesValidateUpdateActionTemplateRaw(requestParameters: ActionsTemplatesValidateUpdateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.actionsTemplatesValidateUpdateActionTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an action template
     */
    async actionsTemplatesValidateUpdateActionTemplate(requestParameters: ActionsTemplatesValidateUpdateActionTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.actionsTemplatesValidateUpdateActionTemplateRaw(requestParameters, initOverrides);
    }

}
